export default {"src":"/_next/static/media/online-store.0839f205.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};